export const baseUrl = "https://api.kalantarelectric.ir";
// export const baseUrl = "http://192.168.10.112:8000";
